import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SuccessPage.css';

function SuccessPage() {
  const [mpesaCode, setMpesaCode] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const navigate = useNavigate();

  // const copyTillNumber = () => {
  //   navigator.clipboard.writeText('9444110');
  //   alert('Till number copied to clipboard!');
  // };

  const handleConfirmPayment = () => {
    if (!mpesaCode.trim()) {
      alert('Please paste your M-Pesa confirmation code');
      return;
    }
    
    setShowConfirmation(true);
    
    setTimeout(() => {
      setShowConfirmation(false);
      alert('Application submitted successfully!');
      navigate('/');
    }, 2000);
  };

  return (
    <div className="success-page">
      <div className="container">
        <div className="success-content">
          <div className="success-icon">🎉</div>
          <h2>Congratulations!</h2>
          <p className="success-message">You are qualified for the loan!</p>
          
          <div className="instructions">
            <h3>To complete your application:</h3>
            <p>Send processing fee of <strong>Ksh 200</strong> through:</p>
            
            <div className="payment-info">
              <div className="info-item">
                <span className="info-label">Till Number:</span>
                <span className="info-value">9444110</span>
              </div>
              <div className="info-item">
                <span className="info-label">Till Name:</span>
                <span className="info-value">FIDELITY PRIME SOLUTIONS</span>
              </div>
            </div>

            <div className="procedure">
              <h4>Procedure:</h4>
              <ol>
                <li>Go to <strong>M-Pesa</strong></li>
                <li>Select <strong>Lipa Na M-Pesa</strong></li>
                <li>Select <strong>Buy Goods and Services</strong></li>
                <li>Enter Till Number: <strong>9444110</strong></li>
                <li>Enter Amount: <strong>200</strong></li>
                <li>Enter your M-Pesa PIN</li>
                <li>Wait for confirmation message</li>
              </ol>
            </div>
          </div>

          {/* Payment Section - Always visible */}
          <div className="payment-section">
            <h3>Payment Verification</h3>
            <p className="payment-instruction">
              After making the payment, paste your M-Pesa confirmation code below:
            </p>
            
            <div className="payment-card">

              <div className="mpesa-section">
                <label htmlFor="mpesaCode">Paste M-Pesa Confirmation Code *</label>
                <textarea
                  id="mpesaCode"
                  value={mpesaCode}
                  onChange={(e) => setMpesaCode(e.target.value)}
                  placeholder="Paste the confirmation code from your M-Pesa message here..."
                  rows="4"
                />
                <small>Find this code in your M-Pesa confirmation message</small>
              </div>

              <button 
                className="confirm-btn"
                onClick={handleConfirmPayment}
                disabled={!mpesaCode.trim()}
              >
                Confirm Payment
              </button>
            </div>
          </div>
        </div>
      </div>

      {showConfirmation && (
        <div className="confirmation-overlay">
          <div className="confirmation-modal">
            <div className="modal-content">
              <div className="modal-icon">✅</div>
              <h3>Application Submitted</h3>
              <p>Thank you for your application! We'll process it and contact you shortly.</p>
              <p className="regards">Best regards,<br />NyotaFund Team</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SuccessPage;